import {takeLatest, all} from 'redux-saga/effects';
import {DMTypes} from '../state/AppRedux';
import {authenticate, forgetPasswordRequest, updatePasswordRequest, getAvailableActions} from './authenticationSaga';
import {settingRequest,} from './settingSaga';
import {getAllAssessment, submitAssessment} from './assessmentSaga';
import {getAllDashboard} from './dashboardSaga';
import {getAllIntervention, submitIntervention, sendAnswers, sendAnswersAndFetchActions} from './interventionSaga';
import {getAllQuestions} from './questionsSaga';

export default function* root() {
	yield all([
		takeLatest(DMTypes.AUTHENTICATE, authenticate),
		takeLatest(DMTypes.FORGET_PASSWORD_REQUEST, forgetPasswordRequest),
		takeLatest(DMTypes.UPDATE_PASSWORD_REQUEST, updatePasswordRequest),
		takeLatest(DMTypes.SETTING_REQUEST, settingRequest),
		takeLatest(DMTypes.GET_ALL_DASHBOARD, getAllDashboard),
		takeLatest(DMTypes.GET_ALL_ASSESSMENT, getAllAssessment),
		takeLatest(DMTypes.SUBMIT_ASSESSMENT, submitAssessment),
		takeLatest(DMTypes.GET_ALL_INTERVENTION, getAllIntervention),
		takeLatest(DMTypes.SUBMIT_INTERVENTION, submitIntervention),
		// some sagas only receive an action
		//takeLatest(DMTypes.STARTUP, startup),
		// Call `authenticate()` when a `FETCH_AUTH_TOKEN` action is triggered
		takeLatest(DMTypes.FETCH_AUTH_TOKEN, authenticate),
		// Call `getAllQuestions()` when a `FETCH_QUESTIONS` action is triggered
		takeLatest(DMTypes.FETCH_QUESTIONS, getAllQuestions),
		// Call `getActions()` when a `FETCH_ACTIONS` action is triggered
		takeLatest(DMTypes.FETCH_ACTIONS, getAvailableActions),
		// // Call `sendAnswers()` when a `SUBMIT_ANSWERS` action is triggered
		takeLatest(DMTypes.SUBMIT_ANSWERS, sendAnswers),
		// // Call reset password
		// takeLatest(DMTypes.RESET_PASSWORD, resetPassword),
		// // Call update settings on action call
		// takeLatest(DMTypes.UPDATE_SETTINGS, updateSettings),
		// // Answer Survey
		// takeLatest(DMTypes.ANSWER_SURVEY, answerSurvey),
		// // Start image pre fetching
		// takeLatest(DMTypes.PRE_FETCH_IMAGES, startPreFetching),
		// // Submit answers and fetch dashboard actions
		takeLatest(DMTypes.SUBMIT_ANSWERS_AND_FETCH_ACTIONS, sendAnswersAndFetchActions)
	]);
}

